import * as React from 'react'
import { Divider, Grid } from '@mui/material'
import GridItem from 'src/components/grid-item/GridItem'
import { SerasaPersonRow } from 'src/modules/serasa/serasa.pf.types'

export type ContatosProps = {
    person: SerasaPersonRow
}

export default function Contatos({ person }: ContatosProps) {
    if (!person.contatos) {
        return <></>
    }

    return (
        <>
            <Divider textAlign="center">Contato</Divider>

            <Grid container spacing={1} paddingTop={2} paddingBottom={2} paddingLeft={5} paddingRight={5}>
                <GridItem label="Celular" value={person.contatos.tel_celular} xs={3} />
                <GridItem label="Tel. Residencial" value={person.contatos.tel_residencial} xs={3} />
                <GridItem label="Tel. Comercial" value={person.contatos.tel_comercial} xs={3} />
                <GridItem label="Tel. Comercial Ramal" value={person.contatos.tel_comercial_ramal} xs={3} />
            </Grid>
        </>
    )
}
